import { FEATURE_SPONSORED_SLOT } from '../constants';
import { adProductFeatureStrategy } from '../strategies';
import type { FeatureConfig } from '../types';

export const sponsoredSlotFeature: FeatureConfig = {
  name: FEATURE_SPONSORED_SLOT,
  toFeature({ productFeatures }) {
    return {
      name: this.name,
      enabled: adProductFeatureStrategy('SponsoredSlot', productFeatures),
    };
  },
};
